import script from "./VipProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./VipProduct.vue?vue&type=script&setup=true&lang=js"

import "./VipProduct.vue?vue&type=style&index=0&id=bae898ec&lang=less&scoped=true"
import "./VipProduct.vue?vue&type=style&index=1&id=bae898ec&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bae898ec"]])

export default __exports__